<template>
  <PrescriptionInfoPage :config="config" />
</template>

<script>
import PrescriptionInfoPage from '@/components/smallComponents/PrescriptionInfoPage.vue'

export default {
  components: { PrescriptionInfoPage },
  data() {
    return {
      config: {
        pageTitle: '处方信息',
        useInfoTitle: '处方使用信息',
        showSymptoms: true,
        submitRouteMode1: '/prescriptionResult',
        submitRouteMode2: '/commonHandmadePrescription',
        btnTextMode1: '提交处方信息',
        btnTextMode2: '请输入药方',
        showGanZhiLabel: false,
        supportMode: true,
        showMainTabCard: true,
      },
    }
  },
}
</script>
<style scoped>
</style>
